module.exports = __webpack_public_path__ + "media/entities/3006-a1fe958a.png";